import * as DeliveryNotesTypes from './transactions.types';
import { ITableColumnsSelectOrderState } from 'interfaces/tables.interface';
import { IInitialTransactionsState } from 'interfaces/transactions.interface';
import { IgetDeliveryNotesData } from 'api/endpoints/transactions/transactions.response.interface';

export type TtransactionsDispatchReducer =
  // Delivery Notes
  | {
      type: typeof DeliveryNotesTypes.SET_DELIVERY_NOTES_ITEMS;
      payload: IgetDeliveryNotesData;
    }
  | {
      type: typeof DeliveryNotesTypes.SET_IS_LOADING_DELIVERY_NOTES_ITEMS;
      payload: boolean;
    }
  | {
      type: typeof DeliveryNotesTypes.SET_DELIVERY_NOTES_COLUMNS_ORDER;
      payload: Record<string, ITableColumnsSelectOrderState>;
    }
  // Bills
  | { type: typeof DeliveryNotesTypes.SET_BILLS_ITEMS; payload: IgetDeliveryNotesData }
  | { type: typeof DeliveryNotesTypes.SET_IS_LOADING_BILLS_ITEMS; payload: boolean }
  | {
      type: typeof DeliveryNotesTypes.SET_BILLS_COLUMNS_ORDER;
      payload: Record<string, ITableColumnsSelectOrderState>;
    }
  // Orders
  | { type: typeof DeliveryNotesTypes.SET_ORDERS_ITEMS; payload: IgetDeliveryNotesData }
  | { type: typeof DeliveryNotesTypes.SET_IS_LOADING_ORDERS_ITEMS; payload: boolean }
  | {
      type: typeof DeliveryNotesTypes.SET_ORDERS_COLUMNS_ORDER;
      payload: Record<string, ITableColumnsSelectOrderState>;
    };

export default function transactionsReducer(
  state: IInitialTransactionsState,
  action: TtransactionsDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    // Delivery Notes /////////////////////////////////////////////
    case DeliveryNotesTypes.SET_DELIVERY_NOTES_ITEMS: {
      const setDeliveryNotesItems: IInitialTransactionsState = {
        ...state,
        deliveryNotesItems: payload,
      };
      return setDeliveryNotesItems;
    }

    case DeliveryNotesTypes.SET_IS_LOADING_DELIVERY_NOTES_ITEMS: {
      const setIsLoadingDeliveryNotesItems: IInitialTransactionsState = {
        ...state,
        isLoadingDeliveryNotesItems: payload,
      };
      return setIsLoadingDeliveryNotesItems;
    }

    case DeliveryNotesTypes.SET_DELIVERY_NOTES_COLUMNS_ORDER: {
      const setColumnsOrder: IInitialTransactionsState = {
        ...state,
        deliveryNotesColumnsOrder: payload,
      };
      return setColumnsOrder;
    }

    // Bills ////////////////////////////////////////////////////////
    case DeliveryNotesTypes.SET_BILLS_ITEMS: {
      const setBillsItems: IInitialTransactionsState = {
        ...state,
        billsItems: payload,
      };
      return setBillsItems;
    }

    case DeliveryNotesTypes.SET_IS_LOADING_BILLS_ITEMS: {
      const setIsLoadingBillsItems: IInitialTransactionsState = {
        ...state,
        isLoadingBillsItems: payload,
      };
      return setIsLoadingBillsItems;
    }

    case DeliveryNotesTypes.SET_BILLS_COLUMNS_ORDER: {
      const setBillsColumnsOrder: IInitialTransactionsState = {
        ...state,
        billsColumnsOrder: payload,
      };
      return setBillsColumnsOrder;
    }

    // Orders ////////////////////////////////////////////////////////
    case DeliveryNotesTypes.SET_ORDERS_ITEMS: {
      const setOrdersItems: IInitialTransactionsState = {
        ...state,
        ordersItems: payload,
      };
      return setOrdersItems;
    }

    case DeliveryNotesTypes.SET_IS_LOADING_ORDERS_ITEMS: {
      const setIsLoadingOrdersItems: IInitialTransactionsState = {
        ...state,
        isLoadingOrdersItems: payload,
      };
      return setIsLoadingOrdersItems;
    }

    case DeliveryNotesTypes.SET_ORDERS_COLUMNS_ORDER: {
      const setOrdersColumnsOrder: IInitialTransactionsState = {
        ...state,
        ordersColumnsOrder: payload,
      };
      return setOrdersColumnsOrder;
    }

    default:
      return state;
  }
}
